import add from 'date-fns/add'
import format from 'date-fns/format'
import isWeekend from 'date-fns/isWeekend'
import startOfToday from 'date-fns/startOfToday'

import freshDataPublicHolidays from 'src/data/_static/publicHolidays.json'

const publicHolidays = freshDataPublicHolidays

const isDateWorkingDay = (date: Date): boolean => {
  if (isWeekend(date)) {
    return false
  }

  if (publicHolidays.includes(format(date, 'yyyy-MM-dd'))) {
    return false
  }

  return true
}

export const isSubscriptionShipmentFulfillable = (date: Date): boolean => {
  // Don't allow Mondays for Subscription scheduling.
  if (date.getDay() === 1) {
    return false
  }

  return isDateWorkingDay(date)
}

export const getEarliestShipmentDate = (startDate: Date = startOfToday()): string => {
  const nextDay = add(startDate, { days: 1 })

  if (!isDateWorkingDay(nextDay)) {
    return getEarliestShipmentDate(nextDay)
  }

  return format(nextDay, 'dd.MM.yyyy')
}
